import { BASE_URL, WS_TYPE } from '@/config/constant'

export function createVideoUrl(guid: string, mode?: string) {
	return `${WS_TYPE}://${BASE_URL}/stream/${guid}.flv?type=${mode || "main"}`
}

export interface obj2StrType {
	[key: string]: any;
}
export function obj2Str(obj: obj2StrType): string {
	let temp = obj
	if (Object.keys(temp).length !== 0) {
		let result = ''
		for (let k in temp) {
			result += `${k}=${temp[k] == null ? '' : (transSymbol(temp[k].toString() || ''))}&`
		}
		return result.substring(0, result.length - 1)
	} else {
		return ''
	}
}
export function transSymbol(str: string): string {
	return str == '' ? '' : (str.replaceAll('%', '%25').replaceAll('#', '%23').replaceAll('&', '%26').replaceAll('+', '%2B').replaceAll('/', '%2F').replaceAll('?', '%3F'))
}

/**
 * 清除对象的字符串value前后空格
 */
export interface trimObjType {
	[key: string]: any;
}
export function trimObj(obj: trimObjType): trimObjType {
	let temp = obj
	for (let k in temp) {
		if (Object.prototype.toString.call(temp[k]) === '[object Object]') {
			trimObj(temp[k])
		} else if (typeof temp[k] == 'string') {
			temp[k] = temp[k].trim()
		} else {
			temp[k] = temp[k]
		}
	}
	return temp
}

// 根据文件路径获取文件名,不包括扩展名
export function getFileName(filePath: string): string {
	const parts = filePath.split('/');
	const fileNameWithExt = parts.pop() || '';
	const fileNameParts = fileNameWithExt.split('.');
	fileNameParts.pop();
	return fileNameParts.join('.') || '';
}

// 随机16位字符串（加密用）
export function getRandomStr16() {
	const str = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
	let randomStr = ''
	for (let i = 0; i < 16; i++) {
		randomStr += str.charAt(Math.floor(Math.random() * str.length))
	}
	return randomStr
}

export function formatLocation(lat: number, lng: number): string {
  if (!lat || !lng) {
    return ''
  }
  return `${lat}, ${lng}`
}

// 获取设备经纬度：有 tower 字段则取杆塔坐标，否则取设备自身坐标
export function getDeviceCoord(device: any): { latitude: number; longitude: number } {
  const source = device?.tower ? device.tower : device
  return {
    latitude: Number(source?.latitude) || 0,
    longitude: Number(source?.longitude) || 0,
  }
}